import ActivateDeactivateButton from "@app/components/activate-deactivate-button.tsx";
import ActivateDeactivateIndicator from "@app/components/activate-deactivate-indicator.tsx";
import ActiveIndicator from "@app/components/active-indicator.tsx";
import { RostersModel } from "@app/data/engine.ts";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (id: number) => void;
    onView: (id: RostersModel) => void;
    onUpdateSortBy: (id: number, sortBy: number) => void;
    onActivateDeactivate: (id: number, active: boolean) => void;
    minSort: number;
    maxSort: number;
    rowCount: number;
}

const columnHelper = createColumnHelper<RostersModel>();
export const AssignmentRosterTableDefinition = ({
    onEdit,
    onView,
    onUpdateSortBy,
    onActivateDeactivate,
    minSort,
    maxSort,
    rowCount,
}: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original.rosterId!)}>
                    <EditIcon />
                </IconButton>
                <IconButton tooltip={"Details"} onClick={() => onView(item.row.original)}>
                    <VisibilityIcon />
                </IconButton>
                <IconButton
                    tooltip={"Move Up"}
                    onClick={() => onUpdateSortBy(item.row.original.rosterId!, item.row.original.sortBy! - 1)}
                    disabled={item.row.original.sortBy! <= minSort}
                >
                    <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton
                    tooltip={"Move Down"}
                    onClick={() => onUpdateSortBy(item.row.original.rosterId!, item.row.original.sortBy! + 1)}
                    disabled={item.row.original.sortBy! >= maxSort}
                >
                    <KeyboardArrowDownIcon />
                </IconButton>
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.displayName, { id: "name", header: "Staff Name" }),
    columnHelper.accessor((x) => x.roleName, { id: "roleName", header: "Role" }),
    columnHelper.accessor((x) => x.active, {
        id: "active",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Active
                <ActivateDeactivateIndicator />
            </Box>
        ),
        cell: (item) => (
            <ActivateDeactivateButton
                isActive={item.getValue() ?? false}
                onClick={() => onActivateDeactivate(item.row.original.rosterId!, !item.getValue()!)}
            />
        ),
    }),
    columnHelper.accessor((x) => x.hasBudget, {
        id: "hasBudget",
        name: "Has Budget",
        header: () => (
            <Box display={"flex"} alignItems={"center"} gap={2}>
                Has Budget
            </Box>
        ),
        cell: (item) => <ActiveIndicator isActive={item.getValue() ?? false} />,
    }),
    columnHelper.accessor((x) => x.sortBy, { id: "sortBy", header: "Sort By", alignment: "right" }),
];
